import React from "react";
import { Film, X } from "lucide-react";
import { useClock } from "@/lib/clock";
import { useAuth } from "@/lib/auth";

export default function DemoBanner() {
  const { demoOn, now, clearDemo } = useClock();
  const { guest } = useAuth();

  // Only show to the couple/admin — guests should never see it
  if (!demoOn || guest?.role !== "admin") return null;

  const when = now.toLocaleString("es-ES", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Madrid",
  });

  return (
    <div
      data-testid="demo-banner"
      className="sticky top-0 z-[60] w-full bg-[color:var(--ink-wine)] text-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 text-xs sm:text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Film size={14} className="shrink-0 animate-pulse" />
          <span className="font-semibold tracking-wide">
            Modo Demo
          </span>
          <span className="opacity-80 truncate">
            · viendo la web como a las <strong>{when}</strong>
          </span>
        </div>
        <button
          onClick={clearDemo}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/15 hover:bg-white/25 text-[0.7rem] font-bold uppercase tracking-[0.18em] transition-colors shrink-0"
          data-testid="demo-banner-stop"
        >
          <X size={12} /> Salir del demo
        </button>
      </div>
    </div>
  );
}
